'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseSignupValidator = exports.PASSWORD_MIN_LENGTH = undefined;

var _reactIntl = require('react-intl');

var _regexes = require('constants/regexes');

var _verify = require('helpers/verify');

var _password = require('validators/password');

var PASSWORD_MIN_LENGTH = exports.PASSWORD_MIN_LENGTH = 6;

var messages = (0, _reactIntl.defineMessages)({
  required: {
    id: 'signup.form.validations.genericRequired',
    defaultMessage: 'This information is required.'
  },
  invalidEmail: {
    id: 'signup.form.validations.invalidEmail',
    defaultMessage: 'Please enter a valid email.'
  }
});

var baseSignupValidator = exports.baseSignupValidator = function baseSignupValidator(data) {
  var errors = {};

  if ((0, _verify.isBlank)(data.password)) {
    errors.password = messages.required;
  } else if ((0, _password.passwordValidator)(data.password)) {
    errors.password = (0, _password.passwordValidator)(data.password);
  }

  if ((0, _verify.isBlank)(data.firstName)) {
    errors.firstName = messages.required;
  }

  if ((0, _verify.isBlank)(data.lastName)) {
    errors.lastName = messages.required;
  }

  if ((0, _verify.isBlank)(data.email)) {
    errors.email = messages.required;
  } else if (!_regexes.EMAIL_REGEX.test(data.email)) {
    errors.email = messages.invalidEmail;
  }

  return errors;
};